import script from "./TopPerformanceCampg.vue?vue&type=script&setup=true&lang=js"
export * from "./TopPerformanceCampg.vue?vue&type=script&setup=true&lang=js"

import "./TopPerformanceCampg.vue?vue&type=style&index=0&id=38da868a&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38da868a"]])

export default __exports__